import validators from '../utils/validators';

class Functional {
  /**
   * @param data
   */
  constructor(data) {
    const properties = {
      id: (v) => validators.isNotEmptyString(v),
      health: (v) => validators.isNotEmptyString(v),
      title: (v) => validators.isNotEmptyString(v),
      description: (v) => validators.isStringOrNull(v),
    };

    for (const property of Object.keys(properties)) {
      if (properties[property](data[property]) !== true) {
        throw new Error(`Invalid property ${property} in ${data.id}`);
      }

      this[property] = data[property];
    }
  }
}

export default Functional;
